export default __webpack_public_path__ + "static/media/HeroImageMaisProtegido.ea24423b.png";